import React, { lazy } from 'react';

// project imports
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

const ErrorPage = Loadable(lazy(() => import('views/Error')));

// ===========================|| AUTH ROUTING ||=========================== //

const ErrorRoutes = {
    path: '*',
    element: (
        <NavMotion>
            <ErrorPage />
        </NavMotion>
    )
};

export default ErrorRoutes;
